import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'

export const IsoWeekday = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7
}

const currentDate = moment()
const julyFirst = moment()
  .date(1) // day is 1 based
  .month(6) // month is 0 based
export const defaultStartDate: Moment = currentDate.isBefore(julyFirst)
  ? julyFirst.subtract(1, 'years')
  : julyFirst
export const defaultEndDate: Moment = currentDate

export function validateDateParam(dateParam?: string | null | undefined): number | null {
  if (dateParam !== null && dateParam !== undefined && /^\d+$/.test(dateParam)) {
    const m = moment(parseInt(dateParam, 10))
    if (m.isValid()) {
      return m.valueOf()
    }
  }
  return null
}
